import { render, staticRenderFns } from "./optionBox.vue?vue&type=template&id=ab982070&"
import script from "./optionBox.vue?vue&type=script&lang=js&"
export * from "./optionBox.vue?vue&type=script&lang=js&"
import style0 from "./optionBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports